import { Empty } from 'src/antd';
import React from 'react';
import { LoadingIndicator } from '@/components/application/loading-indicator/loading-indicator';

const Spinner = () => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '3rem',
      }}
    >
      <LoadingIndicator type="line-simple" size="md" />
    </div>
  );
};

const NoData = () => (
  <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    style={{ width: '100%', padding: '3rem' }}
  />
);

export const TableKit = {
  NoData,
  Spinner,
};
